interface ServiceWorkerUpdatePromptProps {
  show: boolean;
}

/**
 * Informational only: a normal refresh loads the update when the user is ready.
 */
const ServiceWorkerUpdatePrompt = ({
  show,
}: ServiceWorkerUpdatePromptProps) => {

  if (!show) {
    return null;
  }

  return (
    <div
      role='status'
      aria-live='polite'
      className='fixed inset-x-0 bottom-4 z-[9999] mx-auto flex w-fit max-w-[92vw] items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-sm text-white shadow-lg'
    >
      <span>มีเวอร์ชันใหม่พร้อมใช้งาน เมื่อสะดวก โปรดรีเฟรชหน้า หรือปิดแอปแล้วเปิดใหม่เพื่ออัปเดต</span>
    </div>
  );
};

export default ServiceWorkerUpdatePrompt;
